import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { charactersList } from "Utils/Helpers/TableColumns";
import Pagination from "@mui/material/Pagination";

export default function TableCharactersData({ data, onChangePage }) {
  const onPageChange = async (event, newPage) => {
    if (data.paginattion.page !== newPage) {
      onChangePage(newPage);
    };
  };

  return (
    <div className="d-flex flex-column align-items-center gap-2">
      <DataGridComponent
        data={data.data}
        columns={charactersList}
        rowHeight={75}
      />
      <Pagination
        count={data.paginattion.totalPages}
        page={data.paginattion.page}
        shape="rounded"
        size="small"
        className={data.paginattion.totalPages === 1 ? 'd-none' : ''}
        onChange={onPageChange}
        hidePrevButton
        hideNextButton
      />
    </div>
  );
}
